"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { DESIGNS, useDesign, withBase } from "./design";

// Плашка «Дизайн: Институт · Каталог · Спорт» — одна на все три дизайна.
// Ведёт на ту же страницу в другом дизайне; корзина и счётчик общие, потому что живут вне дизайна.
export default function DesignSwitch() {
  const { design, base } = useDesign();
  const path = usePathname() || "/";
  const [hash, setHash] = useState("");
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const read = () => setHash(window.location.hash);
    read();
    window.addEventListener("hashchange", read);
    return () => window.removeEventListener("hashchange", read);
  }, []);

  const rest = base && path.startsWith(base) ? path.slice(base.length) || "/" : path;

  if (!open)
    return (
      <button type="button" className="dsw-pill dsw-mini" onClick={() => setOpen(true)} aria-label="Показать переключатель дизайна">
        Дизайн
      </button>
    );

  return (
    <nav className="dsw-pill" aria-label="Дизайн сайта">
      <span className="dsw-lbl">Дизайн</span>
      {DESIGNS.map((d) => (
        <Link
          key={d.id}
          href={withBase(d.base, rest) + hash}
          className={`dsw-opt${d.id === design ? " dsw-on" : ""}`}
          aria-current={d.id === design ? "page" : undefined}
          title={d.note}
          // без предзагрузки: иначе браузер заранее тянет шрифты и код двух других дизайнов
          prefetch={false}
        >
          {d.label}
        </Link>
      ))}
      <Link href="/showcase" className="dsw-about" prefetch={false}>
        О проекте
      </Link>
      <button type="button" className="dsw-x" aria-label="Скрыть переключатель" onClick={() => setOpen(false)}>
        ×
      </button>
    </nav>
  );
}
